import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#ffffff03',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'white',
  },
  '&:nth-of-type(even)': {
    backgroundColor: 'white',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createData(name, data1, data2, data3) {
  return { name, data1, data2, data3 };
}

const rows = [
  createData('PPE Compliance', 159, 'Medium Risk', '7 minutes ago'),
  createData('Crowd Control', 237, 'Low Risk', '15 minutes ago'),
  createData('Vehicle Safety', 262, 'Medium Risk', '12 minutes ago'),
  createData('Zone Inactivicty', 305, 'High Risk', '9 minutes ago'),
];

export default function XTable({ head = ['SCORE BREAK DOWN', 'Score', 'Status', 'Last Alert'] }) {
  return (
    <TableContainer component={Paper} sx={{backgroundColor: '#ffffff24'}}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            {head?.map((h) => <StyledTableCell>{h}</StyledTableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.name}>
              <StyledTableCell component="th" scope="row">{row.name} </StyledTableCell>
              <StyledTableCell align="right">{row.data1}</StyledTableCell>
              <StyledTableCell align="left">{row.data2}</StyledTableCell>
              <StyledTableCell align="left">{row.data3}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
